import React from 'react';
import randomstring from 'uuid/v4';
import { Bar } from 'react-chartjs-2';

// eslint-disable-next-line
//import ChartDataLabels from 'chartjs-plugin-datalabels';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import Attach from '@material-ui/icons/AttachFile';

import PeriodLabel from './PeriodLabel';

function getDataSet(serie) {

    const total = serie && serie.total ? serie.total : undefined;
    const showValue = serie && !serie.total ? true : false ;

    const datasets = [{
                        type: "bar",
                        label: '',
                        data: serie && serie.valores 
                                    ? serie.valores.map((d) => {
                                            if(showValue) return d.y;
                                            return  Math.round(((d.y) / total) * 100);
                                        })
                                    : undefined,
                        backgroundColor: 'rgba(85, 94, 212, 1)',
                    }];

    if(serie.totalRef ||  (serie.valores && serie.valores.reduce((result, item) => {return result || item.ref}, false))) {
        datasets.push({
            label: '',
            type: "line",
            backgroundColor: '#d7dfe6',
            data: serie.valores.map((d) => {
                        if(!serie.totalRef) {
                            return d.ref;
                        }
                        return  Math.round(((d.ref) / serie.totalRef) * 100);
                    })
        });
    }

    return {
        labels: serie.valores.map((d) => {
            return d.x.split(' ');
        }),
        datasets: datasets,
    };
}

const flatNodes = (node, add) => {
    node.path = `${add}${node.nombre}`;
    let result = [node];
    if (node.hijos) {
        node.hijos.forEach((c) => (result = result.concat(flatNodes(c , add + ' '))));
    }
    return result;
};

class BarChart extends React.Component {

    state = {
        widget: undefined,
        legend: ''
    }


    static getDerivedStateFromProps(props, state) {
        const { widget } = props;
        if (widget !== state.widget) {
            state.widget = widget;
            state.jerarquia = widget && widget.jerarquia && widget.jerarquia.length > 0 ? flatNodes(widget.jerarquia[0], '') : [];
            state.node = widget && widget.jerarquia && widget.jerarquia.length > 0 ? widget.jerarquia[0].id : undefined;
            state.sets = widget && widget.sets && Object.keys(widget.sets).map((i) => { return {id: i, nombre: widget.sets[i]}; });
            state.set = state.sets && state.sets.length > 0 ? state.sets[0].id : undefined;
            state.serie = state.node && state.set ? widget.series[`${state.set}_${state.node}`] : undefined;
            state.data = state.serie ?  getDataSet(state.serie) : {};
            state.legend = state.serie && !state.serie.total ? ' ' : '%' ;

            console.log(state);
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        const { widget } = this.state;
        let estado = this.state;
        estado[event.target.name] = event.target.value;
        const serie = estado.set ? widget.series[estado.set && estado.node ? `${estado.set}_${estado.node}` : `${estado.set}`] : undefined;
        const data = serie ?  getDataSet(serie) : {};
        const legend = serie && !serie.total ? ' ' : '%' ;
        this.setState({ 
                        [event.target.nombre]: event.target.value,
                        serie: serie,
                        data: data,
                        legend: legend,
                        //max: max
                     });
    };

    render() {
        const {intl} = this.props;
        const { widget, sets, set, jerarquia, node, data, legend } = this.state;
        return (<div className="flex_full_column  padding_12">
                    <div className="flex_auto_row width100">
                        <Attach className={'attachIcon'} onClick={this.props.onDownload(this.props.data)} />
                        <span className="flex_full_row center barlowcondensed_medium c_lipstick uppercase">
                            {widget.nombre}
                        </span>
                        <PeriodLabel {...this.props} />
                    </div>
                    <div className="flex_full_column margin_top_4 center">
                    <article className="canvas-container-dashboard">
                        <Bar
                            redraw={true} 
                            height={200}
                            width={100}
                            data={data}
                            options={{
                                events: false,
                                tooltips: {
                                    enabled: false
                                },
                                hover: {
                                    animationDuration: 0
                                },
                                responsive: true,
                                maintainAspectRatio: false,
                                legend: {
                                    display: false,
                                    position: 'bottom',
                                },
                                plugins: {
                                    datalabels: {
                                      anchor: 'end',
                                      align: 'top',
                                      formatter: Math.round,
                                      font: {
                                        size: 10,
                                      },
                                      color: '#424e61'
                                    }
                                },
                                scales: {
                                    yAxes: [
                                        {
                                            scaleLabel: {
                                                display: true,
                                                labelString: legend,
                                            },
                                            ticks: {
                                                beginAtZero: true,
                                                //min: 0,
                                                //max: max
                                            },
                                        },
                                    ],
                                    xAxes: [{
                                        scaleLabel: {
                                            fontStyle: 'italic'
                                        },
                                        ticks: {
                                            autoSkip: true,
                                            fontColor: "#2996cc",
                                            maxRotation: 0,
                                            minRotation: 0,
                                            fontSize: 10,
                                            fontStyle: 'italic'
                                        }
                                    }]
                                },
                            }}
                        />
                    </article>
                    </div>
                    <div className="margin_top_8 flex_auto_row width100" >
                        <FormControl className={'flex_full width100 barlow_italic_medium c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'widget_title_series' })}
                            </InputLabel>
                            <Select
                                native
                                value={set}
                                fullWidth
                                className="barlow_italic_medium"
                                onChange={this.handleChange}
                                inputProps={{ name: 'set', id: 'set' }}
                                >
                                    <option key={randomstring()} value={undefined} />
                                    {sets &&
                                        sets.length > 0 &&
                                        sets.map((s) => {
                                            return (
                                                <option key={randomstring()} value={s.id}>
                                                    {s.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="margin_top_8 flex_auto_row width100" >
                        <FormControl className={'flex_full width100 barlow_italic_medium c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'process_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={node}
                                fullWidth
                                className="barlow_italic_medium"
                                onChange={this.handleChange}
                                inputProps={{ name: 'node', id: 'node' }}
                                >
                                    <option key={randomstring()} value={undefined} />
                                    {jerarquia &&
                                        jerarquia.length > 0 &&
                                        jerarquia.map((s) => {
                                            return (
                                                <option key={randomstring()} value={s.id}>
                                                    {s.path}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                </div>

            );
    }
}


export default BarChart;


// WEBPACK FOOTER //
// ./src/components/complex/dashboard/types/BarChart.js